(() => {
 'use strict';

 const tmCopy = {"Pause": ["Pause", "Pausa", "Pause"], "Mettre le défilement en pause": ["Bildwechsel pausieren", "Mettere in pausa lo scorrimento", "Pause slideshow"], "Lecture": ["Start", "Avviare", "Play"], "Lancer le défilement": ["Bildwechsel starten", "Avviare lo scorrimento", "Start slideshow"]};
 function tmSay(source) {
  const index = ["de", "it", "en"].indexOf(typeof document === "undefined" ? "fr" : document.documentElement.lang.split("-")[0]);
  return tmCopy[source]?.[index] ?? source;
 }

 function init(root) {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const slides=[...root.querySelectorAll('[data-duo-slide]')];
  const controls=root.querySelector('[data-duo-controls]');
  if(slides.length<2 || !controls) return;
  const dots=[...root.querySelectorAll('[data-duo-to]')];
  const pause=root.querySelector('[data-duo-pause]');
  const track=root.querySelector('.tm-duo__slides');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let current=0, timer=null, hovered=false, inView=true;
  let paused=root.dataset.autoplay!=='true' || reduced.matches;
  controls.hidden=false;
  function clear(){clearTimeout(timer);timer=null;}
  function schedule(){clear();if(!paused&&!hovered&&inView&&!document.hidden) timer=setTimeout(()=>show(current+1),Number(root.dataset.interval)||8000);}
  function sync(){pause.textContent=paused?tmSay("Lecture"):tmSay("Pause");pause.setAttribute('aria-label',paused?tmSay("Lancer le défilement"):tmSay("Mettre le défilement en pause"));track.setAttribute('aria-live',paused?'polite':'off');}
  function show(next){current=(next+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});dots.forEach((dot,i)=>{if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});schedule();}
  function manual(next){paused=true;sync();show(next);}
  root.querySelector('[data-duo-prev]').addEventListener('click',()=>manual(current-1));
  root.querySelector('[data-duo-next]').addEventListener('click',()=>manual(current+1));
  dots.forEach(dot=>dot.addEventListener('click',()=>manual(Number(dot.dataset.duoTo))));
  pause.addEventListener('click',()=>{paused=!paused;sync();schedule();});
  root.addEventListener('mouseenter',()=>{hovered=true;clear();});
  root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
  root.addEventListener('focusin',(e)=>{if(e.target!==pause){paused=true;sync();clear();}});
  root.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();manual(current+1);}else if(e.key==='ArrowLeft'){e.preventDefault();manual(current-1);}});
  document.addEventListener('visibilitychange',schedule);
  reduced.addEventListener('change',()=>{if(reduced.matches)paused=true;sync();schedule();});
  if('IntersectionObserver' in window) new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.2}).observe(root);
  document.addEventListener('shopify:block:select',e=>{const index=slides.findIndex(slide=>slide.contains(e.target));if(index>=0)manual(index);});
  sync();schedule();
 }
 function boot(){document.querySelectorAll('[data-tm-duo]').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
